import { FormGroup, FormControlLabel, Checkbox, Stack } from "@mui/material";
import classNames from "classnames";
import { ReactNode } from "react";

export const HdgCheckboxGroup = <T = string,>({
  value,
  onChange,
  options,
  direction = "column",
  className,
}: {
  value: T[];
  onChange: (value: T[]) => void;
  options: { value: string; label: ReactNode }[] | string[];
  direction?: "row" | "column";
  className?: string;
}) => {
  const handleChange = (changeValue: T) => {
    if (value.includes(changeValue)) {
      onChange(value.filter((v) => v !== changeValue));
    } else {
      onChange([...value, changeValue]);
    }
  };

  return (
    <FormGroup>
      <Stack
        className={classNames("selection-container", className)}
        direction={direction}
        spacing={2}
        flexWrap="wrap"
      >
        {options.map((option) => {
          if (typeof option === "string") {
            return (
              <FormControlLabel
                className="hdg-checkbox-label"
                key={option}
                control={
                  <Checkbox
                    name={option}
                    value={option}
                    checked={value.includes(option as T)}
                    onChange={(e) => handleChange(option as T)}
                  />
                }
                label={option}
              />
            );
          }

          return (
            <FormControlLabel
              className="hdg-checkbox-label"
              key={option.value}
              control={
                <Checkbox
                  name={option.value}
                  value={option.value}
                  checked={value.includes(option.value as T)}
                  onChange={(e) => handleChange(option.value as T)}
                />
              }
              label={option.label}
            />
          );
        })}
      </Stack>
    </FormGroup>
  );
};
